import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, adminOnly }) => {
  const { user, loading, userRole, isPasswordReset } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // If user is in password reset flow, redirect to reset password page
  if (isPasswordReset) {
    return <Navigate to="/reset-password" />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // If this is an admin-only route and user is not an admin or super admin
  if (adminOnly && userRole !== 'admin' && userRole !== 'super_admin') {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute; 